<template>
  <div class="app-container">
    <div ref="gantt" class="left-container"></div>
  </div>
</template>
<script>
import gantt from 'dhtmlx-gantt'; // 引入模块
//import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'
import 'dhtmlx-gantt/codebase/skins/dhtmlxgantt_terrace.css'; //皮肤
import 'dhtmlx-gantt/codebase/locale/locale_cn'; // 本地化
import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js'; //任务条悬浮提示

export default {
  name: 'Gantt',
  props: {
    dataForm: Object,
  },
  data() {
    return {
      newList: [],
      tasks: {
        data: [
          // {
          //   id: 1,
          //   text: '计划时间',
          //   start_date: '2020-04-08',
          //   duration: 10,
          //   open: true, //默认打开，
          //   toolTipsTxt: 'xxxxxxxxxxxxxxxxx'
          // },
          // {
          //   toolTipsTxt: 'xxxxxxxxxxxxxxxxx父任务01-001',
          //   text: '冒烟阶段', // 任务名
          //   start_date: '2020-04-08', // 开始时间
          //   id: 11, // 任务id
          //   duration: 3, // 任务时长，从start_date开始计算
          //   parent: 1, // 父任务ID
          //   type: 1
          // },
          // {
          //   toolTipsTxt: '',
          //   text: '单元测试', // 任务名
          //   start_date: '2020-04-11', // 开始时间
          //   id: 12, // 任务id
          //   duration: 2, // 任务时长，从start_date开始计算
          //   parent: 1, // 父任务ID
          //   type: 2
          //
          // },
          // {
          //   toolTipsTxt: '',
          //   text: '回归测试', // 任务名
          //   start_date: '2020-04-13', // 开始时间
          //   id: 13, // 任务id
          //   duration: 4, // 任务时长，从start_date开始计算
          //   parent: 1, // 父任务ID
          //   type: 3
          //
          // },
          // {
          //   toolTipsTxt: '',
          //   text: '阶段四', // 任务名
          //   start_date: '2020-04-13', // 开始时间
          //   id: 14, // 任务id
          //   duration: 4, // 任务时长，从start_date开始计算
          //   parent: 1, // 父任务ID
          //   type: 4
          //
          // },
          // //========================
          // {
          //   id: 2,
          //   text: '实际时间',
          //   start_date: '2020-04-08',
          //   duration: 8,
          //   open: true, //默认打开，才可隐藏左侧表格
          //   toolTipsTxt: 'xxxxxxxxxxxxxxxxx',
          //   state: 'default'
          //   // color:"#409EFF",
          //   //progress: 0.6
          // },
          // {
          //   toolTipsTxt: 'xxxxxxxxxxxxxxxxx父任务01-001',
          //   text: '冒烟阶段', // 任务名
          //   start_date: '2020-04-08', // 开始时间
          //   id: 21, // 任务id
          //   duration: 2, // 任务时长，从start_date开始计算
          //   parent: 2, // 父任务ID
          //   type: 1
          // },
          // {
          //   toolTipsTxt: '',
          //   text: '单元测试', // 任务名
          //   start_date: '2020-04-09', // 开始时间
          //   id: 22, // 任务id
          //   duration: 2, // 任务时长，从start_date开始计算
          //   parent: 2, // 父任务ID
          //   type: 2
          // },
          // {
          //   toolTipsTxt: '',
          //   text: '回归测试', // 任务名
          //   start_date: '2020-04-11', // 开始时间
          //   id: 23, // 任务id
          //   duration: 2, // 任务时长，从start_date开始计算
          //   parent: 2, // 父任务ID
          //   type: 3
          // }
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //开始时间-结束时间参数
    DateDifference: function(strDateStart, strDateEnd) {
      const begintime_ms = Date.parse(new Date(strDateStart.replace(/-/g, '/'))); //begintime 为开始时间
      const endtime_ms = Date.parse(new Date(strDateEnd.replace(/-/g, '/'))); // endtime 为结束时间
      const date3 = endtime_ms - begintime_ms; //时间差的毫秒数
      const days = Math.floor(date3 / (24 * 3600 * 1000));
      return days;
    },
    digui(data) {
      data.map(res => {
        const date1 = new Date(res.startTime);
        const date2 = new Date(res.endTime);
        const date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24); /*不用考虑闰年否*/
        this.newList.push({
          id: res.id,
          text: res.name,
          start_date: res.startTime.substring(0, 10),
          duration: date + 1,
          parent: res.parentTaskId,
          open: true, //默认打开，
        });
        if (data.childList) {
          this.digui(data.childList);
        }
      });
      return this.newList;
    },

    initData: function() {
      // const date1 = new Date(this.dataForm.startTime);
      // const date2 = new Date(this.dataForm.endTime);
      // const date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24); /*不用考虑闰年否*/
      // this.newList = [];
      // this.newList.push({
      //   id: this.dataForm.id,
      //   text: this.dataForm.name,
      //   start_date: this.dataForm.startTime.substring(0, 10),
      //   duration: date + 1,
      //   parent: this.dataForm.parentTaskId,
      //   open: true, //默认打开，
      // });
      // this.digui(this.dataForm.childList)
      // this.tasks.data = this.newList;

      const newArr = [];
      this.dataForm.childList.map(res => {
        const date1 = new Date(res.startTime);
        const date2 = new Date(res.endTime);
        const date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24); /*不用考虑闰年否*/
        newArr.push({
          id: res.id,
          text: res.name,
          start_date: res.startTime.substring(0, 10),
          duration: date + 1,
          // parent: res.parentTaskId,
          open: true, //默认打开，
        });
      });
      this.tasks.data = newArr;
      this.tasks.data.map(function(current, ind, arry) {
        let newObj = {};
        // if (current.type) { //存在type字段 说明非一级菜单，判断阶段的具体类型 设置不同颜色
        //   if (current.type == 1) { //冒烟
        //     newObj = Object.assign({}, current, { 'color': '#fcca02' })
        //   } else if (current.type == 2) { //单元
        //     newObj = Object.assign({}, current, { 'color': '#fec0dc' })
        //   } else if (current.type == 3) { //回归
        //     newObj = Object.assign({}, current, { 'color': '#62ddd4' })
        //   } else if (current.type == 4){
        //     newObj = Object.assign({}, current, { 'color': '#d1a6ff' })
        //   }
        // } else {
        //一级菜单是蓝色的
        newObj = Object.assign({}, current, { color: '#5692f0' });
        // }

        return newObj;
      });
    },

    checkData: function() {
      // '@typescript-eslint/no-this-alias':['off']
      const _that = this;
      this.initData();
      // const newDate = new Date();
      // const newA = newDate.getFullYear() - 2 + '-01-01';
      // const newB = newDate.getFullYear() + 3 + '-01-01';
      // /*
      //  * 冒烟：fcca02    单元：fec0dc     回归：62ddd4   阶段：d1a6ff
      //  * */
      // //设置图表区域的日期坐标最大值 var date = new Date(dateString.replace(/-/,"/"))
      // gantt.config.start_date = new Date(newA.replace(/-/, '/'));
      // gantt.config.end_date = new Date(newB.replace(/-/, '/')); //结束时间需要+1天

      //自适应甘特图的尺寸大小, 使得在不出现滚动条的情况下, 显示全部任务
      gantt.config.autosize = true;
      //只读模式
      gantt.config.readonly = true;
      //是否显示左侧树表格
      gantt.config.show_grid = true;
      //表格列设置
      gantt.config.columns = [
        { name: 'text', label: '子任务名称', tree: true, width: '220', height: '220' },
        // {
        //   name: 'duration', label: '时长', align: 'center', template: function(obj) {
        //     return obj.duration + '天'
        //   }
        // }
        /*{name:"start_date", label:"开始时间", align: "center" },

          {name:"end_date",   label:"结束时间",   align: "center" },*/
      ];
      //时间轴图表中，如果不设置，只有行边框，区分上下的任务，设置之后带有列的边框，整个时间轴变成格子状。
      gantt.config.show_task_cells = true;

      //设置x轴日期
      gantt.config.scale_unit = 'month';
      // gantt.config.step = 1
      gantt.config.date_scale = '%Y' + '年' + '%F';

      //当task的长度改变时，自动调整图表坐标轴区间用于适配task的长度
      gantt.config.fit_tasks = true;
      // 在时间线上增加一行显示星期
      gantt.config.subscales = [
        // {unit:"day",  step:1, date:"星期"+"%D" },
        // { unit: 'day', step: 1, date: '%M' + '%d' + '日' },
        { unit: 'day', step: 1, date: '%d' },
      ];
      //时间轴图表中，任务条形图的高度
      gantt.config.task_height = 28;
      //时间轴图表中，甘特图的高度
      gantt.config.row_height = 36;
      //从后端过来的数据格式化
      gantt.config.xml_date = '%Y-%m-%d';
      //任务条显示内容
      gantt.templates.task_text = function(start, end, task) {
        return task.text + '(' + task.duration + '天)';
      };
      // gantt.templates.task_class = function(start, end, task){return "xx";};
      //悬浮
      gantt.templates.tooltip_text = function(start, end, task) {
        const newD = new Date(new Date(end).getTime() - 1000 * 60 * 60 * 24);
        const y = start.getFullYear();
        let m = start.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = start.getDate();
        d = d < 10 ? '0' + d : d;

        const h = newD.getFullYear();
        let i = newD.getMonth() + 1;
        i = i < 10 ? '0' + i : i;
        let j = newD.getDate();
        j = j < 10 ? '0' + j : j;
        start = y + '/' + m + '/' + d;
        end = h + '/' + i + '/' + j;

        return '<b>子任务名称:</b> ' + task.text + '<br/><b>时长:</b> ' + task.duration + '天' + '<br/><b>时间段:</b>' + start + '-' + end;
        // return '<span style=\'font-size: 14px\'>' + task.toolTipsTxt + '</span>'
      };

      gantt.templates.scale_cell_class = function(date) {
        if (date.getDay() == 0 || date.getDay() == 6) {
          return 'weekend';
        }
        return 'weekend';
      };
      //任务栏周末亮色
      gantt.templates.task_cell_class = function(item, date) {
        if (date.getDay() == 0 || date.getDay() == 6) {
          return 'weekend';
        }
      };
      //任务条上的文字大小 以及取消border自带样式
      gantt.templates.task_class = function(start, end, item) {
        return item.$level == 0 ? 'firstLevelTask' : 'secondLevelTask';
      };

      gantt.attachEvent('onTaskRowClick', function(id, row) {
        //any custom logic here
        _that.$emit('choose', id);
      });
      // 初始化
      gantt.init(this.$refs.gantt);
      // 数据解析
      gantt.parse(this.tasks);
    },

    destro() {
      gantt.clearAll();
    },
  },
};
</script>
<style lang="scss">
.gantt_grid_scale {
  height: 45px !important;
}

.gantt_scale_cell {
  border-bottom: 1px solid #ebebeb !important;
}

.gantt_scale_line {
  height: 22px !important;
  line-height: 22px !important;
  /*border-top: 1px solid #ebebeb;*/
}

.firstLevelTask {
  border: none;
  .gantt_task_content {
    // font-weight: bold;
    border-radius: 20px;
    font-size: 13px;
  }
}

.secondLevelTask {
  border: none;
}

.thirdLevelTask {
  border: 2px solid #da645d;
  color: #da645d;
  background: #da645d;
}

.milestone-default {
  border: none;
  background: rgba(0, 0, 0, 0.45);
}

.milestone-unfinished {
  border: none;
  background: #5692f0;
}

.milestone-finished {
  border: none;
  background: #84bd54;
}

.milestone-canceled {
  border: none;
  background: #da645d;
}

html,
body {
  margin: 0px;
  padding: 0px;
  height: 100%;
  overflow: hidden;
}

.container {
  height: 900px;
  .left-container {
    height: 100%;
  }
}

.left-container {
  height: 300px;
}

.gantt_scale_line {
  border-top: 0;
}

.weekend {
  background: #f4f7f4 !important;
  color: #000000 !important;
}

.gantt_selected .weekend {
  background: #f7eb91 !important;
}

.gantt_task_content {
  text-align: left;
  padding-left: 10px;
}

//上面任务条样式
.gantt_task_scale {
  height: 45px !important;
}

.gantt_task .gantt_task_scale .gantt_scale_cell {
  line-height: 30px !important;
  height: 28px !important;
}
</style>

<style>
.gantt_task .gantt_task_scale .gantt_scale_cell {
  line-height: 30px !important;
  height: 23px !important;
}

.gantt_scale_cell {
  color: #a6a6a6 !important;
}

.gantt_task_line {
  /*top: 4px !important;*/
  height: 21px !important;
  line-height: 20px !important;
  border-radius: 20px !important;
  background-color: rgba(255, 86, 86, 0.7) !important;
}
</style>
